import {USER_ROOT_API_URL} from "../../../../config/settings.js"

export const GET_NOTIFICATIONS = USER_ROOT_API_URL + "/get_notifications"
export const UPDATE_NOTIFICATION_STATUS = USER_ROOT_API_URL + "/update_notification_status"
export const REMOVE_FRIEND_REQUEST = USER_ROOT_API_URL + "/remove_friend_request"

export const GET_NEW_NOTIF_COUNT = USER_ROOT_API_URL + "/get_new_notif_count"
export const SET_LAST_SEEN = USER_ROOT_API_URL + "/set_last_seen"
